export default __webpack_public_path__ + "static/media/icons-instagram.76a6e728.svg";